module.exports = __webpack_public_path__ + "media/images/motto-bg2-320-21a32a24df4e8ca7629e60711e78e456.png";